var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n    Copyright\n    "),_c('a-icon',{attrs:{"type":"copyright"}}),_vm._v("\n    2020 "),_c('span',[_vm._v("金牌厨柜效能信息部 出品")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }